import axios from 'axios';
import { getEnv } from '../config';

const api = axios.create({
    baseURL: getEnv("REACT_APP_API_URL") ? getEnv("REACT_APP_API_URL") : 'https://visualizador-back-dev.gcba.gob.ar/',
    withCredentials: true,
  });
  
  // Interceptor para añadir el token a las peticiones
  api.interceptors.request.use((config) => {
    const token = JSON.parse(localStorage.getItem('auth'))?.token;
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  });
  
  export class APIError extends Error {
    constructor(status, message) {
      super(message);
      this.name = 'APIError';
      this.status = status;
    }
  }
  
  export const loginAPI = async (code, redirect_ur) => {
    try {
      const response = await api.post('/auth/callback', { code, redirect_ur });
      return response.data;
    } catch (error) {
      
      if (error.isAxiosError) {
        throw new APIError(error.response?.status || 500, error.response?.data?.message);
      }
      throw error;
    }
  };

  export const logoutAPI = async () => {
    try {
      const response = await api.post('/auth/logout');
      return response.data;
    } catch (error) {
      throw new APIError(error.response?.status || 500, error.response?.data?.message);
    }
  };
  
  

  
  export default api;